import { call, put, select, takeLatest } from "redux-saga/effects";
import { ActionTypes } from "./types";
import { failure, success } from "./actions";
import { snack } from "components/GlobalSnackbar";
import { getError } from "utils";
import { RootState } from "../root_reducer";
import { api, cacheDados } from "configs";
import { IMensagemCategoria } from "@deltasge/marauders-map";

function* request() {
  try {
    const {
      usuario: { usuario },
    }: RootState = yield select();

    if (!usuario) {
      throw new Error("Usuário não encontrado");
    }

    const cache24h = 60 * 24;
    const key = `mensagem-categoria-${usuario?.escolaId}`;
    const cache = cacheDados.get<IMensagemCategoria[]>(key);
    if (cache && typeof cache != "string") {
      yield put(success(cache));
    } else {
      const { data } = yield call(api.get, "educador/mensagem-categoria");
      if (!data || !Array.isArray(data) || !Array.isArray(data.at(0))) {
        throw new Error("Nenhuma categoria de mensagem encontrada");
      }
      yield put(success(data[0] as IMensagemCategoria[]));
      cacheDados.set(key, data[0] as IMensagemCategoria[], cache24h);
    }
  } catch (error) {
    yield put(failure());
    snack.error(getError(error));
  }
}
export const sagas = takeLatest([ActionTypes.REQUEST], request);
